import React from 'react';
import { Box, Link, Text } from 'bumbag';
import format from 'date-fns/format';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { DescriptionLabel } from '@medipass/react-core';

type Props = {
  created: string;
  modality?: Record<string, any>;
  practice?: Record<string, any>;
  staff?: Record<string, any>;
  invoiceReference?: string;
};

export default function CheckoutServiceDetails({ created, modality, practice, staff, invoiceReference }: Props) {
  return (
    <div className="space-y-6">
      <Box textAlign="center" fontSize="150">
        <time dateTime={created}>{format(created, 'DD/MM/YYYY hh:mmA')}</time>
      </Box>
      {invoiceReference && (
        <Box>
          <DescriptionLabel>INVOICE REFERENCE</DescriptionLabel>
          <Box fontWeight="semibold">{invoiceReference}</Box>
        </Box>
      )}
      <div className={`grid grid-cols-1 gap-x-8 gap-y-4 ${staff && practice ? 'min-[600px]:grid-cols-2' : ''}`}>
        {staff && (
          <Box>
            <DescriptionLabel>PROVIDER</DescriptionLabel>
            <Box fontWeight="semibold">
              {staff.firstName} {staff.lastName}
            </Box>
            {modality && (
              <Box lineHeight="1.1em">
                <Text fontSize="150">{modality.displayName}</Text>
              </Box>
            )}
          </Box>
        )}
        {practice && (
          <Box>
            <DescriptionLabel>PRACTICE</DescriptionLabel>
            <Box fontWeight="semibold">{practice.displayName}</Box>
            <Box lineHeight="1.1em">
              <Text fontSize="150">
                {_get(practice, 'showAddress', true) && !_isEmpty(practice.address) && (
                  <Box lineHeight="1.1em">
                    {practice.address}
                    <br />
                    {practice.city}, {practice.state}
                    <br />
                  </Box>
                )}
                {(practice.landline || practice.mobile) && (
                  <Link href={`tel:${practice.landline || practice.mobile}`}>
                    {practice.landline || practice.mobile}
                  </Link>
                )}
              </Text>
            </Box>
          </Box>
        )}
      </div>
    </div>
  );
}
